export const teacherMessages = {
    emailAddress: 'Email address (school-issued email address)',
    continueToLevis: "CONTINUE TO LEVI'S",
    loading: 'Loading...',
    militaryStatus: 'Military status',
    noOptions: 'No options',
    personalInformation: 'Personal Information',
    personalOrSchoolIsFine: 'Personal or school email is fine',
    postalCode: 'Postal code',
    poweredBy: 'Verification services powered by SheerID',
    requiredFields: 'All fields are required',
    school: 'School',
    schoolName: 'School name',
    sheerIdFaqs: 'SheerID FAQs',
    teacherInfoShared: 'Information entered into this web form will be used for verification purposes. The information will be shared with Levi\'s.',
    universityName: 'University name',
    verifyAndContinue: 'Verify and continue',
    verifyMyTeacherStatus: 'VERIFY MY TEACHER STATUS',
    verificationPurposesOnly: 'Used for verification purposes only',
    step: {
        personalInfo: {
            subtitle: 'Verify you\'re a teacher, faculty or staff at a K-12 or degree-granting university.',
            title: 'UNLOCK THIS TEACHER-ONLY OFFER',
            countries: {
                US: 'United States',
            },
            locales: {
                'en-US': 'English',
            },
        },
        docUpload: {
            acceptableUploadExamples: 'Acceptable examples include:',
            acceptedTypes: 'File must be .jpg .png  .pdf .gif or .bmp',
            title: 'WE NEED SOME MORE INFO',
            subtitle: 'Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.',
            footer: null,
            submitButtonLabel: 'SUBMIT',
            cancelButtonLabel: 'CANCEL',
            howDoesReviewWorkDetails: 'Document review is handled by SheerID, a trusted partner who specializes in verifying teachers.<br/><br/>Documents are used only for verifying your teacher status is current and will be permanently deleted after review is finalized. They will not be shared with {companyName}.',
            uploadInstructions: 'Upload your school-issued document that shows:',
            estimatedWaitTime: 'a few minutes',
        },
        pending: {
            subtitle: 'SheerID is reviewing your documents, to confirm your status. <br><br> This process may take up to 20 minutes.',
            title: 'PROCESSING',
            subtitle2: 'Wait here or let us notify you of the outcome. <br> You will be contacted via email.',
            maxReviewTime: '20 minutes',
        },
        success: {
            title: 'SUCCESS! YOU\'VE BEEN VERIFIED',
            subtitle: 'Here is your personal coupon code. It is unique to you and can only be used once.',
            redirectUrl: 'https://www.levi.com/',
            redirectButtonText: 'CONTINUE',
            copyCouponCode: 'Copy promo code',
            emailNotification: 'We have emailed you a copy so you can use your new code now or later. Look for an email from verify@sheerid.com',
        },
    },
};
